import * as React from "react";
import ExternalLink from "../../../../../../../components/Navigation/ExternalLink";
import { buildServerPackagingInstruction } from "../../Instructions";
import { CommonTextForOctopusCli, CommonBuildServerPackagingTextForIntegration } from "../CommonRegistrationText";
const BuildServerPackaging: React.FC<{}> = () => (<div>
        <p>
            When packaging other applications from build servers, we recommend using the{" "}
            <ExternalLink href={"cli"} label={"Octopus CLI"}>
                Octopus CLI
            </ExternalLink>
            .
        </p>
        {CommonTextForOctopusCli}
        {CommonBuildServerPackagingTextForIntegration}
    </div>);
BuildServerPackaging.displayName = "BuildServerPackaging"
export default buildServerPackagingInstruction(() => <BuildServerPackaging />);
